import { Text } from "@mantine/core";

import { ObservationDisplayProps } from "./interfaces";

export function ObservationQuantityDisplay({
  observation,
  showUnit = true,
  emptyText = "",
  ...others
}: ObservationDisplayProps) {
  if (!observation) {
    return <Text {...others}>{emptyText}</Text>;
  }

  const value = observation.valueQuantity?.value;
  const unit = observation.valueQuantity?.unit;
  const valueDisplay = unit && showUnit ? `${value} ${unit}` : value?.toString();

  return <Text {...others}>{value && valueDisplay}</Text>;
}
